export enum PortalPedidoStatusEnum {
  Invalido = 0,
  Pendente = 1,
  Confirmado = 2,
  Encerrado = 3,
}
